// Fetch list

export const FETCH = 'reportTrailerCosts.FETCH'
export const FETCH_STARTED = 'reportTrailerCosts.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportTrailerCosts.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportTrailerCosts.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportTrailerCosts.FETCH_CANCELLED'

// Export

export const EXPORT = 'reportTrailerCosts.EXPORT'
export const EXPORT_FULFILLED = 'reportTrailerCosts.EXPORT_FULFILLED'

// Clear

export const CLEAR = 'reportTrailerCosts.CLEAR'

// Fetch details

export const FETCH_DETAILS = 'reportTrailerCosts.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportTrailerCosts.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportTrailerCosts.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportTrailerCosts.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportTrailerCosts.FETCH_DETAILS_CANCELLED'

// Export details

export const EXPORT_DETAILS = 'reportTrailerCosts.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportTrailerCosts.EXPORT_DETAILS_FULFILLED'

// Clear details

export const CLEAR_DETAILS = 'reportTrailerCosts.CLEAR_DETAILS'
